export default function getEnv () {
  // 
  const domain = window?.location?.hostname;
  if (domain === 'test-platform.ads.ahaglobal.io' || domain === 'test.platform.aha.inc' || domain === 'localhost') {
    return 'development';
  }
  if (domain === 'platform.ads.ahaglobal.io' || domain === 'platform.aha.inc') {
    return 'production';
  }
  return 'production';
}